import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentHeroComponent } from './component-hero.component';
import { ButtonModule } from 'primeng/button';
import { DirectiveModule } from 'src/app/directive/directive.module';

@NgModule({
  declarations: [
    ComponentHeroComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    DirectiveModule
  ],
  exports: [
    ComponentHeroComponent
  ]
})
export class ComponentHeroModule { }
